import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'high_side_effect/getEach?';
const allUrl = 'high_side_effect/get?';
const storeUrl = 'high_side_effect/store';
const updateUrl = 'high_side_effect/update?';
const deleteUrl = 'high_side_effect/delete?';
const state = {
  procedures: [],
  procedure: {},
};
const getters = {};
const mutations = {
  SET_PROCEDURES(state, payload) {
    state.procedures = payload.data.data;
  },
  SET_PROCEDURE(state, payload) {
    state.procedure = payload.data.data;
  },
  ADD_PROCEDURE(state, payload) {
    state.procedures.push(payload.data.data);
  },
  REMOVE_PROCEDURE(state, payload) {
    const procedures = state.procedures.filter(
      (item) => item.id != payload.id
    );
    state.procedures = [...procedures];
  },
};

const actions = {
  async get({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PROCEDURES", response);
  },
  async getEach({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_PROCEDURE", response);
  },
  async create({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_PROCEDURE", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async update(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async delete({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_PROCEDURE", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
